import React from "react";
import { useI18n } from "../../lib/i18n";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";

const INTERIOR_IMG =
  "https://images.unsplash.com/photo-1776482128065-ae388030a0b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function InteriorHighlight() {
  const { t } = useI18n();
  const h = t.interiorHighlight;

  return (
    <section
      data-testid="interior-highlight-section"
      className="relative bg-[#0A1428] text-white overflow-hidden"
    >
      <div className="grid lg:grid-cols-2 min-h-[640px]">
        {/* Image side */}
        <div className="relative img-zoom h-[360px] lg:h-auto">
          <img
            src={INTERIOR_IMG}
            alt={h.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0A1428]/30 hidden lg:block" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1428]/60 via-transparent to-transparent lg:hidden" />
        </div>

        {/* Content side */}
        <div className="relative px-6 py-16 lg:px-16 lg:py-24 flex flex-col justify-center">
          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage:
                "url(https://static.prod-images.emergentagent.com/jobs/90dd8daa-cd26-4f72-b7b0-ddd9192df92a/images/637ebb2bbeed047f419e8449b463145a4df9d3b751e4a9fca8c9757ba1af6b9c.png)",
              backgroundSize: "cover",
            }}
          />
          <div className="relative max-w-xl">
            <p className="overline mb-5">{h.overline}</p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl leading-[1.05] tracking-tight font-medium">
              {h.title}
            </h2>
            <p className="mt-5 italic text-[#C5A059] text-lg">{h.tagline}</p>
            <p className="mt-6 text-white/75 text-base lg:text-lg leading-relaxed">
              {h.paragraph}
            </p>

            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {[h.bullet1, h.bullet2, h.bullet3, h.bullet4].map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2.5 text-sm text-white/85"
                >
                  <CheckCircle
                    size={18}
                    weight="duotone"
                    className="text-[#C5A059] flex-shrink-0 mt-0.5"
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            {/* Stats strip */}
            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/15 pt-7">
              <div>
                <div className="font-serif text-3xl text-[#C5A059] font-medium">
                  {h.stat1Value}
                </div>
                <p className="text-[10px] uppercase tracking-widest text-white/55 mt-1.5">
                  {h.stat1Label}
                </p>
              </div>
              <div>
                <div className="font-serif text-3xl text-[#C5A059] font-medium">
                  {h.stat2Value}
                </div>
                <p className="text-[10px] uppercase tracking-widest text-white/55 mt-1.5">
                  {h.stat2Label}
                </p>
              </div>
              <div>
                <div className="font-serif text-3xl text-[#C5A059] font-medium">
                  {h.stat3Value}
                </div>
                <p className="text-[10px] uppercase tracking-widest text-white/55 mt-1.5">
                  {h.stat3Label}
                </p>
              </div>
            </div>

            <a
              href="/#contact"
              data-testid="interior-highlight-cta"
              className="btn-primary mt-10"
            >
              {h.cta} <ArrowRight size={16} weight="bold" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
